"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isArray = isArray;
exports.isMap = isMap;
exports.isSet = isSet;
exports.isString = isString;
exports.isNumber = isNumber;
exports.isBool = isBool;
exports.isObj = isObj;
exports.isFunc = isFunc;
exports.numberHasLength = numberHasLength;
exports.arrayHasItems = arrayHasItems;
exports.isStringMatch = isStringMatch;
exports.isNumberMatch = isNumberMatch;
exports.valueHasValue = valueHasValue;
exports.deepHasValue = deepHasValue;
exports.arrayItemsHasValue = arrayItemsHasValue;
exports.mapHasKeys = mapHasKeys;
exports.mapMatchObj = mapMatchObj;
exports.objHasOwnProperty = objHasOwnProperty;
exports.objHasOwnProperties = objHasOwnProperties;
exports.objHasKeys = objHasKeys;
exports.objKeysHasValue = objKeysHasValue;
exports.objDeepRemoveKey = objDeepRemoveKey;
exports.newMap = newMap;
exports.getFalsyValue = getFalsyValue;
exports.deepCopy = deepCopy;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// type check
function isArray(value) {
  return Array.isArray(value);
}

function isMap(value) {
  return value instanceof Map;
}

function isSet(value) {
  return value instanceof Set;
}

function isString(value) {
  return typeof value === 'string';
}

function isNumber(value) {
  return typeof value === 'number';
}

function isBool(value) {
  return typeof value === 'boolean';
}

function isObj(value) {
  return _typeof(value) === 'object' && !Array.isArray(value);
}

function isFunc(value) {
  return typeof value === 'function';
} // value check


function numberHasLength(value) {
  return isNumber(value) && value > 0;
}

function arrayHasItems(arr) {
  return isArray(arr) && numberHasLength(arr.length);
}

function isStringMatch(value) {
  var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return isString(value) && arr.some(function (a) {
    return a === value;
  });
}

function isNumberMatch(value) {
  var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return isNumber(value) && arr.some(function (a) {
    return a === String(value);
  });
}

function valueHasValue(value) {
  return !!value && value !== null && value !== undefined;
}

function deepHasValue(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    deepArr: false,
    deepObj: true
  };
  var deepArr = options.deepArr,
      deepObj = options.deepObj;

  if (value && isArray(value)) {
    if (deepArr) return arrayHasItems(value) && value.every(function (i) {
      return deepHasValue(i, options);
    }); // without deepArr, having items in array considered as having value

    return arrayHasItems(value);
  }

  if (value && isObj(value)) {
    var keys = Object.keys(value);
    if (deepObj) return arrayHasItems(keys) && keys.every(function (k) {
      return deepHasValue(value[k], options);
    }); // without deepObj, having keys in object considered as having value

    return arrayHasItems(keys);
  }

  return valueHasValue(value);
}

function arrayItemsHasValue(arr) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    deepArr: false,
    deepObj: true
  };
  return arrayHasItems(arr) && arr.every(function (i) {
    return deepHasValue(i, options);
  });
}

function mapHasKeys(map) {
  for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  return isMap(map) && keys.every(function (k) {
    return map.has(k);
  });
}

function mapMatchObj(map, obj) {
  var keys = Object.keys(obj);
  return isObj(obj) && keys.every(function (k) {
    var value = obj[k];
    var mapHasValue = map.has(k);
    var mapValue = map.get(k);
    return mapHasValue && mapValue === value;
  });
}

function objHasOwnProperty(obj, key) {
  return obj && isObj(obj) && Object.prototype.hasOwnProperty.call(obj, key);
}

function objHasOwnProperties(obj) {
  for (var _len2 = arguments.length, keys = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    keys[_key2 - 1] = arguments[_key2];
  }

  return obj && isObj(obj) && keys.every(function (k) {
    return Object.prototype.hasOwnProperty.call(obj, k);
  });
}

function objHasKeys(obj) {
  if (obj && isObj(obj)) {
    var keys = Object.keys(obj);
    return arrayHasItems(keys);
  }

  return false;
}

function objKeysHasValue(obj) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    deepArr: false,
    deepObj: true
  };

  if (obj && isObj(obj)) {
    var newKeys = Object.keys(obj);

    if (arrayHasItems(keys)) {
      newKeys = keys;
    }

    return arrayHasItems(newKeys) && newKeys.every(function (key) {
      return deepHasValue(obj[key], options);
    });
  }

  return false;
}

function objDeepRemoveKey(obj, key) {
  var newObj = obj;

  if (newObj && isObj(newObj)) {
    var keys = Object.keys(newObj);

    if (arrayHasItems(keys)) {
      keys.forEach(function (k) {
        var value = newObj[k];

        if (isObj(value)) {
          newObj[k] = objDeepRemoveKey(value, key);
        } else if (arrayHasItems(value)) {
          newObj[k] = value.map(function (v) {
            if (isObj(v)) {
              return objDeepRemoveKey(v, key);
            }

            return v;
          });
        } else if (k === key) {
          delete newObj[k];
        }
      });
    }
  }

  return newObj;
} // utils


function newMap(obj) {
  var map = new Map();

  if (isObj(obj)) {
    var keys = Object.keys(obj);
    keys.forEach(function (k) {
      var value = obj[k];
      map.set(k, value);
    });
  }

  return map;
}

function getFalsyValue(value) {
  if (value) {
    switch (true) {
      case isBool(value):
        return false;

      case isString(value):
        return '';

      case isNumber(value):
        return 0;

      case isArray(value):
        return [];

      case isObj(value):
        return {};

      default:
        return null;
    }
  }

  return undefined;
}

function deepCopy(target) {
  if (isArray(target) || isObj(target)) {
    // array deepCopy
    if (isArray(target)) {
      var length = target.length;

      var _output = new Array(length);

      if (numberHasLength(length)) {
        for (var i = 0; i < length; i += 1) {
          _output[i] = deepCopy(target[i]);
        }
      }

      return _output;
    } // object deepCopy


    var output = {};
    var keys = Object.keys(target);

    if (arrayHasItems(keys)) {
      keys.forEach(function (k) {
        if (output[k]) {
          output[k] = deepCopy(target[k]);
        }
      });
    }

    return output;
  }

  return target;
}